import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
import moment from "moment";
import router from '@/router';
import TokenService from "@/services/tokenService";

axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Accept'] = 'application/json'
axios.defaults.baseURL = (() => {
  const apiURL = process.env.VUE_APP_API_URL || ''
  if (apiURL.length > 0) {
    return apiURL
  }

  const port = window.location.port ? ':' + window.location.port : ''
  return `${window.location.protocol}//${window.location.hostname}${port}/api`
})()

let numberOfActiveRequests = 0
const tryToCloseLoader = config => {
  if (config.showLoader !== false) numberOfActiveRequests--
  if (!numberOfActiveRequests) store.commit('setLoader', false)
}

axios.interceptors.request.use(
  config => {
    if (config.showLoader !== false) {
      store.commit('setLoader', true)
      numberOfActiveRequests++
    }

    const accessToken = store.state.common.user.access_token
    const tokenData = store.state.common.user.tokenData
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
    }
    if (tokenData && tokenData.exp) {
      const expiration = moment.unix(tokenData.exp)
      const diff = expiration.diff(moment(), 'seconds')
      if (diff < 600) { // let's force user to relogin
        TokenService.clearTokens()
        router.push({
          name: 'auth'
        })
      }
    }
    return config;
  },
  error => {
    showError(error);
    Promise.reject(error);
  }
)

axios.interceptors.response.use(
  response => {
    tryToCloseLoader(response.config)
    return response
  },
  error => {
    console.error(error.response)
    tryToCloseLoader(error.response.config)
    if (typeof error.response.data.message == 'object') {
      for (const item in error.response.data.message) {
        showError(item + ' ' + error.response.data.message[item])
      }
    } else if (error.response.data.message) {
      showError(error.response.data.message)
    }

    return Promise.reject(error)
  }
)

const showError = error => {
  Vue.notify({
    type: 'error',
    text: error
  });
};
